import { Box, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { collection, onSnapshot } from "firebase/firestore";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/config";
import { Match } from "../types";

interface MatchWithId extends Match {
  id: string;
}

const Home: FC = () => {
  const [matches, setMatches] = useState<MatchWithId[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "match"), (snapshot) => {
      const data = snapshot.docs.map((d) => ({
        id: d.id,
        ...(d.data() as Match),
      }));
      setMatches(data);
      setLoading(false);
    });
    return unsub;
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#1a1a2e",
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography variant="h3" color="white" gutterBottom sx={{ fontWeight: 700 }}>
        Gigamatch
      </Typography>
      <Typography variant="subtitle1" color="grey.400" sx={{ mb: 4 }}>
        Selecciona un partido
      </Typography>

      {loading && (
        <Typography color="grey.500">Cargando partidos...</Typography>
      )}

      {!loading && matches.length === 0 && (
        <Typography color="grey.500">No hay partidos disponibles.</Typography>
      )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: 2,
          width: "100%",
          maxWidth: 900,
        }}
      >
        {matches.map((match) => {
          const totalAssigned =
            match.local.assignedSeats + match.visitante.assignedSeats;
          const finished = totalAssigned >= match.totalSeats;

          return (
            <Card key={match.id}>
              <CardActionArea onClick={() => navigate(`/match/${match.id}`)}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                    {match.local.teamUrlImage && (
                      <Box
                        component="img"
                        src={match.local.teamUrlImage}
                        alt={match.local.teamName}
                        sx={{ height: 40, objectFit: "contain" }}
                      />
                    )}
                    <Typography variant="h6" sx={{ flex: 1, textAlign: "center" }}>
                      {match.local.teamName} vs {match.visitante.teamName}
                    </Typography>
                    {match.visitante.teamUrlImage && (
                      <Box
                        component="img"
                        src={match.visitante.teamUrlImage}
                        alt={match.visitante.teamName}
                        sx={{ height: 40, objectFit: "contain" }}
                      />
                    )}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {match.stadiumName} — {match.typeGame}
                  </Typography>
                  <Typography variant="body2" color={finished ? "success.main" : "text.secondary"}>
                    {totalAssigned} / {match.totalSeats} asientos
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export default Home;
